var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-tooltip',{attrs:{"placement":_vm.placement,"enterable":false}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._t("default")],2),_vm._v(" "),_c('i',{staticClass:"mdi mdi-help-circle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }